export class HourToOrder {

    constructor(hour: number, minutes: number, hourToDisplay: string) {
        this.hour = hour;
        this.minutes = minutes;
        this.hourToDisplay = hourToDisplay;
    }

    hour: number;
    minutes: number;
    hourToDisplay: string;
}


// WEBPACK FOOTER //
// C:/Users/Ludo.DESKTOP-F1GO0J2/PhpstormProjects/orderApi/orderApp/src/app/model/HourToOrder.ts